if($('.type-detail').length){
    if(getShoptetDataLayer('customer').registered){
        $('.p-info-wrapper').append('<div class="customCart"></div>');
        $('.customCart').append($('.p-info-wrapper .p-final-price-wrapper'))
        $('.customCart').append($('.p-info-wrapper .add-to-cart'))
    }
    else{
        $('.p-info-wrapper').append('<div class="customCart"><a href="'+$('.link-icon.chat').attr('href')+'" class="link-icon chat">Kontaktujte nás</a></div>');
        
    }
    
    if($('.extended-description').length){
        var $krabiceTable = $('<table id="krabiceTable"><thead><tr><th colspan="2">Krabice</th></tr></thead><tbody></tbody></table>');
        var $paletaTable = $('<table id="paletaTable"><thead><tr><th colspan="2">Paleta</th></tr></thead><tbody></tbody></table>');

        $('.detail-parameters tbody tr').each(function() {
            var $row = $(this);
            var headerText = $row.find('th .row-header-label').text();
            if (headerText.includes('#KRABICE#')) {
                $row.hide()
                $krabiceTable.find('tbody').append('<tr>'+$row.html().replace('#KRABICE#', '')+'</tr>');
            } else if (headerText.includes('#PALETA#')) {
                $row.hide()
                $paletaTable.find('tbody').append('<tr>'+$row.html().replace('#PALETA#', '')+'</tr>');
            }
        });

        $('.p-info-wrapper').append('<div class="table-container"></div>');
        $('.table-container').append($paletaTable).append($krabiceTable);
    }
	$(document).on('click','.buyPalete', function(){
  		var pridat_Value = $(this).attr('data-pieces');
  		var gethodnota = $('.add-to-cart .quantity').find('input.amount').val();
  		var cilovahodnota =  parseFloat(gethodnota)+parseFloat(pridat_Value)
        if(parseFloat(gethodnota) == $('.add-to-cart input.amount').attr('data-min')) {
            $('.add-to-cart .quantity').find('input.amount').val(cilovahodnota - $('.add-to-cart input.amount').attr('data-min')).attr('value', cilovahodnota);
        }
        else {
            $('.add-to-cart .quantity').find('input.amount').val(cilovahodnota).attr('value', cilovahodnota);
        }
	});
}